function normalizePathname(pathname) {
  if (!pathname) {
    return '/'
  }

  return pathname.replace(/\/+$/, '') || '/'
}

export function parseAnchorHref(href, currentLocation) {
  if (!href) {
    return null
  }

  let parsedUrl
  try {
    parsedUrl = new URL(href, currentLocation.href)
  } catch (e) {
    return null
  }

  if (!parsedUrl.hash) {
    return null
  }

  return {
    hash: parsedUrl.hash,
    origin: parsedUrl.origin,
    pathname: normalizePathname(parsedUrl.pathname),
    search: parsedUrl.search,
  }
}

export function isSamePageAnchor(parsedAnchor, currentLocation) {
  if (!parsedAnchor) {
    return false
  }

  return (
    currentLocation.origin === parsedAnchor.origin &&
    normalizePathname(currentLocation.pathname) === parsedAnchor.pathname &&
    currentLocation.search === parsedAnchor.search
  )
}

export function shouldInterceptAnchorClick(event, anchor, parsedAnchor, currentLocation) {
  if (!isSamePageAnchor(parsedAnchor, currentLocation)) {
    return false
  }

  if (event.defaultPrevented || event.button !== 0) {
    return false
  }

  if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) {
    return false
  }

  const target = (anchor.target || '').trim().toLowerCase()
  return target === '' || target === '_self'
}

export function buildAnchorHistoryUrl(currentLocation, hash) {
  return `${currentLocation.pathname}${currentLocation.search}${hash}`
}
